export const REPORT_CURRENCY_TYPE = 'currency' as const
export const REPORT_DATE_TYPE = 'date' as const
export const REPORT_DATETIME_TYPE = 'datetime' as const
export const REPORT_DECIMAL_TYPE = 'decimal' as const
export const REPORT_INTEGER_TYPE = 'int' as const

export const REPORT_DATE_TYPES = [REPORT_DATE_TYPE, REPORT_DATETIME_TYPE] as const

export const REPORT_NUMBER_TYPES = [REPORT_CURRENCY_TYPE, REPORT_DECIMAL_TYPE, REPORT_INTEGER_TYPE] as const

export const REPORT_TABLE_TYPES = [
  REPORT_CURRENCY_TYPE,
  REPORT_DATE_TYPE,
  REPORT_DATETIME_TYPE,
  REPORT_DECIMAL_TYPE,
  REPORT_INTEGER_TYPE,
] as const

export type ReportColumnType = typeof REPORT_TABLE_TYPES[number]
